import React from "react";
import { Navigate } from "react-router-dom";

//Dashboard
import Dashboard from "../pages/Dashboard";

//login
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";

// User Profile
import UserProfile from "../pages/Authentication/user-profile";

import Vehicles from "../pages/Vehicles";
import VehicleDetails from "../pages/Vehicles/Details";

import Parts from "../pages/Parts";

import PartDetailsNew from "../pages/PartDetails/Newindex";
import PartDetails from "../pages/Parts/Details";
import Notes from "../pages/Notes";
import Statistic from "../pages/Statistic";
import FinanceReports from "../pages/FinanceReports";

const authProtectedRoutes = [
  { path: "/vehicles", component: <Vehicles /> },
  { path: "/vehicle-details", component: <VehicleDetails /> },
  { path: "/finances", component: <Statistic /> },
  { path: "/finance-reports", component: <FinanceReports /> },
  { path: "/notes", component: <Notes /> },
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/index", component: <Dashboard /> },
  { path: "/parts", component: <Parts /> },
  { path: "/part-details", component: <PartDetails /> },
  { path: "/part-details-new", component: <PartDetailsNew /> },
  //User Profile
  { path: "/profile", component: <UserProfile /> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  { path: "*", component: <Navigate to="/dashboard" /> },
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> }
];

export { authProtectedRoutes, publicRoutes };
